import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { CharacterChangesSchema } from "../../fragments/CharacterChanges";
const StructuredPatchNotesBladeTypeValues = ["characterChanges", "structuredPatchNotes"];
export const StructuredPatchNotesBladeTypesSchema = z.enum(StructuredPatchNotesBladeTypeValues);
export const StructuredPatchNotesBladeTypes = StructuredPatchNotesBladeTypesSchema.enum;
export const StructuredPatchNotesBladeSchema = BladeCommonSchema.extend({
    title: z.string().optional(),
    characters: z.array(CharacterChangesSchema),
});
export const StructuredPatchNotesBladesContractSchema = StructuredPatchNotesBladeSchema.extend({
    type: StructuredPatchNotesBladeTypesSchema,
});
export const StructuredPatchNotesBladeContractSchema = StructuredPatchNotesBladesContractSchema.extend({
    type: z.literal(StructuredPatchNotesBladeTypes.structuredPatchNotes),
});
export const CharacterChangesBladeContractSchema = StructuredPatchNotesBladesContractSchema.extend({
    type: z.literal(StructuredPatchNotesBladeTypes.characterChanges),
});
//# sourceMappingURL=index.js.map